import { Col, Divider, Form, Modal, Radio, Row } from "antd";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import { CardContainer } from "../../../components/Card/CardContainer";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import Input from "../../../components/Input/Input";
import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";
import { useEffect, useState } from "react";
import { color } from "../../../resource";
import { teamDatasource } from "../../../datasource/TeamDatasource";

export const CreateTeam: React.FC = () => {
  const navigate = useNavigate();
  const [form] = useForm();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isEdit = pathSplit[3] !== "create";
  const teamId = pathSplit[3];
  const [showModal, setModal] = useState(false);
  const location = useLocation();
  const data = location?.state?.row;
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [errMessege, setErrMessege] = useState<string>("");
  const [isErr, setIserr] = useState<boolean>(false);
  const [statusUsed, setStatusUsed] = useState<boolean>(false);

  const getById = async () => {
    const data = await teamDatasource.getTeamById(teamId).then((res) => res.responseData);
    form.setFieldsValue({
      teamId: data.teamId,
      teamName: data.teamName,
      status: data.status,
      statusUsed: data.statusUsed,
    });
    setStatusUsed(form.getFieldsValue(["statusUsed"]).statusUsed);
  };

  const onSubmit = async () => {
    const formValue = form.getFieldsValue(true);

    if (isEdit) {
      try {
        const payload = {
          teamId: teamId,
          company: data.company,
          teamName: formValue.teamName,
          status: formValue.status,
          updatedBy: `${userProfile.firstname} ${userProfile.lastname}`,
        };
        const res = await teamDatasource.patchTeam(payload);
        if (res.success) {
          setModal(false);
          setTimeout(() => {
            navigate(-1);
          }, 500);
        } else {
          setIserr(true);
          setErrMessege(res.developerMessage);
          setModal(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      const payload = {
        company: userProfile.company,
        teamName: formValue.teamName,
        updatedBy: `${userProfile.firstname} ${userProfile.lastname}`,
      };
      try {
        const res = await teamDatasource.postTeam(payload);
        if (res.success) {
          setModal(false);
          setTimeout(() => {
            navigate(-1);
          }, 200);
        } else {
          setIserr(true);
          setErrMessege(res.developerMessage);
          setModal(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const getValue = () => {
    form.setFieldsValue({
      teamName: data?.teamName,
      status: data?.status,
    });
  };
  useEffect(() => {
    if (isEdit) {
      getById();

      // getValue();
    } else {
      form.setFieldsValue({
        teamName: "",
      });
    }
  }, []);

  useEffect(() => {
    if (isErr) {
      form.validateFields(["teamName"]);
    }
  }, [isErr, form]);

  const getRules = () => {
    const rules = [
      {
        required: true,
        message: "โปรดระบุชื่อทีม",
      },
      {
        max: 50,
        message: "*ชื่อทีมต้องมีความยาวไม่เกิน 50 ตัวอักษร",
      },

      isErr
        ? {
            validator: async (_, value) => {
              if (isErr) {
                throw new Error(errMessege);
              }
            },
          }
        : {},
    ];
    return rules;
  };
  return (
    <CardContainer>
      <PageTitleNested
        title={isEdit ? "แก้ไขทีม" : "เพิ่มทีม"}
        showBack
        onBack={() => navigate(`/generalSettings/teamSetting`)}
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการทีม", path: `/generalSettings/teamSetting` },
              {
                text: isEdit ? "แก้ไขทีม" : "เพิ่มทีม",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
      <Divider />
      <Form form={form} layout='vertical' onFinish={() => setModal(true)}>
        <Col>
          <Form.Item name='teamName' label='ชื่อทีม ' rules={getRules()}>
            <Input placeholder='ระบุชื่อทีม' autoComplete='off' />
          </Form.Item>
        </Col>
        {isEdit && (
          <Col>
            <Form.Item
              name='status'
              label='สถานะ'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุสถานะ",
                },
              ]}
            >
              <Radio.Group style={{ width: "100%" }}>
                <Row>
                  <Radio value={"ACTIVE"}>เปิดใช้งาน</Radio>
                </Row>
                <Row>
                  <Radio value={"INACTIVE"} disabled={statusUsed}>
                    ปิดการใช้งาน
                  </Radio>
                </Row>
                {statusUsed && (
                  <Text color='error' fontWeight={400} fontSize={12}>
                    (ไม่สามารถตั้งค่าสถานะ “ปิดการใช้งาน”
                    ได้เนื่องจากมีการใช้งานข้อมูลทีมกับการตั้งค่าอื่นๆ)
                  </Text>
                )}
              </Radio.Group>
            </Form.Item>
          </Col>
        )}

        <Divider />
        <Row justify='space-between' gutter={12}>
          <Col xl={3} sm={6}>
            <Button
              typeButton='primary-light'
              title='ยกเลิก'
              htmlType='submit'
              onClick={() => navigate(`/generalSettings/teamSetting`)}
            />
          </Col>
          <Col xl={15} sm={6}></Col>
          <Col xl={3} sm={6}>
            <Button typeButton='primary' title='บันทึก' htmlType='submit' />
          </Col>
        </Row>
      </Form>
      {showModal && (
        <Modal
          centered
          open={showModal}
          closable={false}
          onOk={onSubmit}
          onCancel={() => setModal(false)}
          destroyOnClose
          cancelText={"ยกเลิก"}
          okText={"ยืนยัน"}
          cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
        >
          <Text level={2}>{isEdit ? "ยืนยันการแก้ไขทีม" : "ยืนยันการเพิ่มทีม"}</Text>
          <br />
          {isEdit ? (
            <>
              <Text level={5} color='Text3'>
                โปรดตรวจสอบรายละเอียดทีมอีกครั้งก่อนกดยืนยัน
              </Text>
              <br />
              <Text level={5} color='Text3'>
                เพราะอาจส่งผลต่อการแสดงผลข้อมูลในระบบ
              </Text>
            </>
          ) : (
            <Text level={5} color='Text3'>
              โปรดตรวจสอบรายละเอียดก่อนกดยืนยัน
            </Text>
          )}
        </Modal>
      )}
    </CardContainer>
  );
};
